import Vue from "vue";
import VueRouter from "vue-router";
// import index from "../views/index/index.vue";
import index from "../views/newlypage/index.vue";

Vue.use(VueRouter);

//获取原型对象上的push函数
var originalPush = VueRouter.prototype.push
    //修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

var routes = [
    // 登录页
    {
        path: "/login",
        name: "login",
        component: () =>
            import ("../views/login/login.vue")
    },
    // 忘记密码
    {
        path: "/forget",
        name: "forget",
        component: () =>
            import ("../views/login/forget.vue")
    },
    //
    {
        path: "/",
        name: "index",
        component: index,
        meta: {
            // 页签标题名称
            title: '青海省少先队'
        }
    },
    // 换密码
    {
        path: "/register",
        name: "register",
        component: () =>
            import ("../views/login/register.vue")
    },
    //新闻中心
    {
        path: "/pressrelease",
        name: "pressrelease",
        component: () =>
            import ("../views/pressrelease/pressrelease.vue")
    },
    //详情页面
    {
        path: "/pressrelease/detail",
        name: "pressreleaseDetail",
        component: () =>
            import ("../views/pressrelease/pressreleaseDetail.vue")
    },

    //红领巾通讯社
    {
        path: "/scarfnewsagencyIndex",
        name: "scarfnewsagencyIndex",
        component: () =>
            import ("../views/scarfnewsagency/scarfnewsagencyIndex.vue")
    },

    //小小主人翁
    {
        path: "/masterIndex",
        name: "masterIndex",
        component: () =>
            import ("../views/master/masterIndex.vue")
    },

    //小小主人翁(意见建议)
    {
        path: "/feedback",
        name: "feedback",
        component: () =>
            import ("../views/feedback/feedback.vue")
    },

    //网络课堂
    {
        path: "/networkclassroomIndex",
        name: "networkclassroomIndex",
        component: () =>
            import ("../views/networkclassroom/networkclassroomIndex.vue")
    },

    //视频网课
    {
        path: "/videoonlinecourse",
        name: "videoonlinecourse",
        component: () =>
            import ("../views/videoonlinecourse/videoonlinecourse.vue")
    },

    //新建-----------------------------------
    //少先队基本知识
    {
        path: "/basicknowledge",
        name: "basicknowledge",
        component: () =>
            import ("../views/newlypage/basicknowledge.vue")
    },
    //队情资讯
    {
        path: "/teaminform",
        name: "teaminform",
        component: () =>
            import ("../views/newlypage/teaminform.vue")
    },
    //专题活动
    {
        path: "/themactivities",
        name: "themactivities",
        component: () =>
            import ("../views/newlypage/themactivities.vue")
    },
    //专题活动详情
    {
        path: "/themactdetail",
        name: "themactdetail",
        component: () =>
            import ("../views/newlypage/themactdetail.vue")
    },
    //学习资料
    {
        path: "/studytrain",
        name: "studytrain",
        component: () =>
            import ("../views/newlypage/studytrain.vue")
    },
    //网络课堂
    {
        path: "/networkroom",
        name: "networkroom",
        component: () =>
            import ("../views/newlypage/networkroom.vue")
    },
    {
        path: "/networkroomdetail",
        name: "networkroomdetail",
        component: () =>
            import ("../views/newlypage/networkroomdetail.vue")
    },
    //文件库
    {
        path: "/filelibrary",
        name: "filelibrary",
        component: () =>
            import ("../views/newlypage/filelibrary.vue")
    },
    {
        path: "/textdetail",
        name: "textdetail",
        component: () =>
            import ("../views/newlypage/textdetail.vue")
    },
    //学习资料
    {
        path: "/learnmaterials",
        name: "learnmaterials",
        component: () =>
            import ("../views/newlypage/learnmaterials.vue")
    },
    //文化产品
    {
        path: "/culturalpro",
        name: "culturalpro",
        component: () =>
            import ("../views/newlypage/culturalpro.vue")
    },

    //标准对课
    {
        path: "/excellentcases",
        name: "excellentcases",
        component: () =>
            import ("../views/newlypage/excellentcases.vue")
    },
    {
        path: "/excellentcases_detail",
        name: "excellentcases_detail",
        component: () =>
            import ("../views/newlypage/excellentcases_detail")
    },
    //光荣版
    {
        path: "/gloriousedit",
        name: "gloriousedit",
        component: () =>
            import ("../views/newlypage/gloriousedit.vue")
    },
    //社会情报站
    {
        path: "/socialintell",
        name: "socialintell",
        component: () =>
            import ("../views/newlypage/socialintell.vue")
    },

    //下载专区
    {
        path: "/downloadzone",
        name: "downloadzone",
        component: () =>
            import ("../views/newlypage/downloadzone.vue")
    },
    //下载专区列表
    {
        path: "/downloadlist",
        name: "downloadlist",
        component: () =>
            import ("../views/newlypage/downloadlist.vue")
    },
    //下载专区详情
    {
        path: "/downloadDetailbox",
        name: "downloadDetailbox",
        component: () =>
            import ("../views/newlypage/downloadDetailbox.vue")
    },
];

var router = new VueRouter({
    // mode: "hash",
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;